"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.knowledge.list': 'Baza wiedzy',
    'route.knowledge.create': 'Dodaj wiedzę',
    'route.knowledge.edit': 'Edytuj wiedzę',
    'route.knowledge.preview': 'Szczegóły Wiedzy',
    'route.knowledge.bulk_upload': 'Masowe przesyłanie wiedzy',
};
